<template>
  <div class="animated fadeIn col-md-12">
    <Search
      :hiddenFields="hiddenFieldList"
      :url="url"
      :title="$lang.searchCompetency"
      :allowFields="$lang.searchcompetencyFildes"
      :remove_item="remove_item"
      config="competency"
      :toggleable="true"
      removeModalSize="xl"
      addModalSize="lg"
      :dynamicButtons="buttons"
      ref="searchCompetency"
    >
      <template slot="addModal" slot-scope="search">
        <AddCompetency
          isModal
          @modal-end-up="search.close"
          @getData="getData"
        />
      </template>
    </Search>
    <Confirm
      v-model="enableConfirm"
      :title="$lang.change_competency_state"
      :description="enableConfirmDescription"
      dynamicClass=""
      :loading="enableConfirmLoading"
      :loadingSpinnerText="$lang.updating_data"
      :preventDefault="true"
      :cancel-title="$lang.no"
      :ok-title="$lang.yes"
      @cancel="cancelEnableConfirm"
      @ok="okEnableConfirm"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";
import AddCompetency from "./addCompetency";
import Confirm from "@/components/base/confirm";
import { pathOr } from "ramda";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "search-competency",
  components: {
    Search,
    AddCompetency,
    Confirm,
  },
  data() {
    return {
      hiddenFieldList: [
        "created_at.jalali",
        "created_by",
        "updated_by",
        "updated_at.jalali",
      ],
      loadingItem: false,
      buttons: [
        {
          id: "0",
          name: "edit",
        },
        {
          id: "1",
          name: "view",
        },
        {
          id: "2",
          name: "enable",
          click: this.showEnableConfirm,
        },
        {
          id: "3",
          name: "addIndicator",
          click: this.showIndicator,
        },
        {
          id: "4",
          name: "delete",
        },
      ],
      Indicators: [],
      competency_selected: null,
      addIndicatorVisible: false,
      competencyIndicatorsTitle: this.$lang.competency_indicators,
      enableConfirm: false,
      enableConfirmLoading: false,
      enableConfirmItem: null,
    };
  },
  computed: {
    url() {
      return generateApiUrl(["kanoon", "competency"]);
    },
    competencyIndicatorsUrl() {
      return generateApiUrl(["kanoon", "competency_indicator"]);
    },
    enableConfirmDescription() {
      const is_enable = pathOr(null, ["is_enable"], this.enableConfirmItem);
      return is_enable
        ? `با غیر فعال سازی این شایستگی، دیگر قابل انتخاب و اتصال جدید به تمرین نمی باشد ولی ارتباطات قبلی قابل استفاده می باشد.
      <br><br><strong>آیا از غیر فعال سازی شایستگی اطمینان دارید؟</strong>`
        : `با فعال سازی این شایستگی، شایستگی قابل انتخاب و اتصال جدید به تمرین می باشد.
      <br><br><strong>آیا از فعال سازی شایستگی اطمینان دارید؟</strong>`;
    },
  },
  methods: {
    pathOr,
    generateApiUrl,
    getCompetencyIndicators(item) {
      this.competencyIndicatorsTitle = this.$lang.competency_indicators.replace(
        "{0}",
        item.name
      );
      let params = {
        per_page: 100,
      };
      return this.$httpService
        .get(this.competencyIndicatorsUrl.replace("{0}", item.id), params)
        .then((response) => {
          let data = response.data.data.result;
          this.Indicators = data;

          return true;
        })
        .catch((err) => {
          this.$notify.error(err.response.data.message);
          throw "error";
        });
    },
    indicatorAdded() {
      this.competencyIndicatorsTitle = "";
      this.Indicators = [];
      this.addIndicatorVisible = false;
      this.$refs.addIndicator.isLoading = false;
    },
    closeAddIndicatorModal() {
      this.competency_selected = null;
      this.competencyIndicatorsTitle = this.$lang.competency_indicators;

      this.addIndicatorVisible = false;
    },
    showIndicator(item) {
      this.$router.push({
        name: "competencyIndicator",
        params: {
          id: item.id,
        },
      });
    },
    remove_item(item) {
      return this.$httpService
        .delete(this.url + "/" + item.id)
        .then((response) => {
          this.$notify.success(response.data.message);
          return true;
        })
        .catch((error) => {
          this.$generateError(error);
          throw "error";
        })
        .finally(() => {
          this.$refs.searchCompetency.getItems();
        });
    },
    getData() {
      this.$refs.searchCompetency.getItems();
    },
    showEnableConfirm(item) {
      this.enableConfirmItem = item;
      this.enableConfirm = true;
    },
    cancelEnableConfirm() {
      this.enableConfirmItem = null;
      this.enableConfirm = false;
    },
    async okEnableConfirm() {
      try {
        this.enableConfirmLoading = true;
        const { id, is_enable } = this.enableConfirmItem;
        const url = generateApiUrl(["kanoon", "competency_id"], [id]);
        const payload = { is_enable: is_enable ? 0 : 1 };
        const response = await this.$httpService.patch(url, payload);
        this.$notify.success(response.data.message);
        this.cancelEnableConfirm();
        this.getData();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.enableConfirmLoading = false;
      }
    },
  },
};
</script>
